import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";

export const TopbarLogo = styled.img`
  width: 125px;
`;

// Navbar Container
export const Navbar = styled.nav.withConfig({
  shouldForwardProp: (prop) => prop !== "themeVariant",
})<{ themeVariant?: "dark" | "light" }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  border-bottom: 1px solid ${colorPalette.blue200};
  background-color: white;
  height: 70px;
  z-index: 1000;
  margin-top: var(--safe-area-inset-top);

  @media (max-width: 992px) {
    height: auto;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
    border-bottom: ${({ themeVariant }) =>
      themeVariant === "dark"
        ? "none"
        : `1px solid ${colorPalette.blue200}`} !important;
    background-color: ${({ themeVariant }) =>
      themeVariant === "dark"
        ? colorPalette.primaryDark
        : "rgba(255, 255, 255, 1)"} !important;
    backdrop-filter: blur(20px) !important;
  }
`;

// Navbar Title
export const NavbarTitle = styled.span`
  color: ${colorPalette.textMain};
  ${typeScale.headingXS};

  @media (max-width: 767.98px) {
    ${typeScale.headingXXSMain};
  }
`;
